import { useQuery } from '@tanstack/react-query';

import { StaleTime } from 'queries/types';

import { accountAddressesQuery } from './queries';

export const useAccountAddresses = () => {
  const query = useQuery({
    staleTime: StaleTime.ONE_HOUR,
    ...accountAddressesQuery,
  });

  return {
    // For now there is only one address
    address: query.data?.addresses?.[0],
    isLoading: query.isLoading,
  };
};
